import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { SpaLandingPageConnected as SpaLandingPageV1 } from './container';
import { SpaLandingPageV2 } from './v2';

type SpaLandingPageVersionProps = {
  language: string;
};

export const SpaLandingPageVersion: FC<SpaLandingPageVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SpaLandingPageV2 {...props} />;
  return <SpaLandingPageV1 {...props} />;
};
